import { RouteType } from './routeType';

import {
  changePasswordRoute,
  loginRoute,
  newPasswordRoute,
  forgotPasswordRoute,
  resetPasswordRoute,
} from './externalRoutes';

import {
  solicitacoesRetornoRoute,
  estoqueRoute,
  logoutRoute,
  movimentacoesRoute,
  meusDados,
  coletaNoCdRoute,
  calendarioRoute,
  CadastroMotoristaRoute,
  CadastroVeiculoRoute,
  BlockListRoute,
  CadastroRoute,
  entregaNoCdRoute,
  AgendamentoRoute,
  confirmacaoRetornoRoute,
  agendamentosRoute,
  ordemCargaRoute,
  atendimentoRoute,
  DashboardRoute,
  dashboardSlaRoute,
  AjudaRoute,
  AjudaRouteAtendimento,
  AjudaRouteEstoque,
  AjudaRouteGeral,
  AjudaRouteMovimentacoes,
  AjudaSolicitacaoRetorno,
  AjudaRouteTracking,
  trackingRoute,
  dashCargaDescargaRoute,
  // devolucaoRoute,
} from './privateRoutes';

export const PRIVATE_ROUTES: RouteType[] = [
  movimentacoesRoute,
  solicitacoesRetornoRoute,
  logoutRoute,
  estoqueRoute,
  confirmacaoRetornoRoute,
  meusDados,
  coletaNoCdRoute,
  agendamentosRoute,
  entregaNoCdRoute,
  ordemCargaRoute,
  calendarioRoute,
  CadastroMotoristaRoute,
  CadastroVeiculoRoute,
  BlockListRoute,
  AgendamentoRoute,
  CadastroRoute,
  DashboardRoute,
  dashboardSlaRoute,
  atendimentoRoute,
  trackingRoute,
  dashCargaDescargaRoute,
  AjudaRoute,
  AjudaRouteMovimentacoes,
  AjudaRouteAtendimento,
  AjudaRouteEstoque,
  AjudaRouteGeral,
  AjudaSolicitacaoRetorno,
  AjudaRouteTracking,
  // devolucaoRoute,
];

export const MENU_ROUTES: RouteType[] = [
  movimentacoesRoute,
  estoqueRoute,
  solicitacoesRetornoRoute,
  AgendamentoRoute,
  DashboardRoute,
  CadastroRoute,
  trackingRoute,
  // devolucaoRoute,
  atendimentoRoute,
  AjudaRoute,
];

export const EXTERNAL_ROUTES: RouteType[] = [
  loginRoute,
  changePasswordRoute,
  newPasswordRoute,
  forgotPasswordRoute,
  resetPasswordRoute,
];
